import React, { Component } from "react";
import Menu from "../Menu/Menu";
import ContactMain from "./ContactMain/ContactMain";

class Contact extends Component {
  render() {
    return (
      <>
        <Menu />
        <ContactMain />
      </>
    );
  }
}

export default Contact;
